import Vue from 'vue';

const mutations = {
  SET_LESSONS: (state, lessons) => {
    state.lessons = lessons;
  },

  SET_COLUMNS: (state, columns) => {
    state.columns = columns;
  },

  SET_CURRENT_PAGE: (state, currentPage) => {
    state.currentPage = currentPage;
  },

  SET_LEVELS: (state, levels) => {
    state.levels = levels;
  },

  SET_PAGE_SIZE: (state, pageSize) => {
    state.pageSize = pageSize;
  },

  SET_TOTAL_COUNT: (state, count) => {
    state.count = count;
  },

  SET_REFRESH_DATE: (state, timestamp) => {
    state.lastRefreshDate = timestamp;
  },

  SET_ORDERING: (state, ordering) => {
    state.ordering = ordering;
  },

  SET_FILTER: (state, { key, value }) => {
    Vue.set(state.filters, key, value);
  },

  SET_LESSONS_TAGS: (state, tags) => {
    state.lessonsTags = tags;
  },

  SET_SEARCH_TAG: (state, tags) => {
    state.searchTags = tags;
  },

  SET_SEARCH_KEYWORD: (state, keywords) => {
    state.searchKeywords = keywords;
  },

  SET_AVAILABLE_FEATURE_GROUPS: (state, groups) => {
    state.availableFeatureGroups = groups;
  },

  RESET_FILTERS: state => {
    state.filters = {};
  },
};

export default mutations;
